import { Modal, ModalProps } from "reactstrap";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as CrossIcon } from "Assets/icon/cross-thin.svg";
import { IconButton } from "components/ui";
import { trackEvent } from "utility/mixpanel";
import { useInViews } from "utility/useInViews";
import { useTranslation } from "lib/i18n/use-translation";

import styles from "./ContentModal.module.scss";

interface ContentModalProps extends Omit<ModalProps, "isOpen" | "toggle"> {
  onClose: () => void;
}

const ContentModal: React.FC<ContentModalProps> = ({
  children,
  onClose,
  ...modalProps
}) => {
  const { t } = useTranslation("components");
  const { ref, inView } = useInViews();
  const location = useLocation();

  const handleClose = () => {
    trackEvent("Content Modal Closed", {
      source: "close_button",
      urlSearchParams: location.search,
    });
    if (onClose) onClose();
  };

  useEffect(() => {
    if (inView) {
      trackEvent("Content Modal Impression", {
        urlSearchParams: location.search,
      });
    }
  }, [inView, location.search]);

  return (
    <div className={styles["modal-wrapper"]}>
      <IconButton
        icon={<CrossIcon width={24} height={24} />}
        onClick={handleClose}
        aria-label={t("components:contentModal.closeA11y")}
        className={styles["modal-close-icon"]}
        variant="ghost"
      />
      <Modal
        isOpen
        toggle={handleClose}
        onClosed={handleClose}
        backdrop
        contentClassName={styles["modal-content"]}
        centered
        {...modalProps}
      >
        <div ref={ref}>{children}</div>
      </Modal>
    </div>
  );
};

export default ContentModal;
